import { useRef, useEffect } from "react"

export default function useInfiniteScroll(
  callback: () => void,
  canLoadMore: boolean
) {
  const observerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!canLoadMore) return

    const node = observerRef.current
    if (!node) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          callback()
        }
      },
      { threshold: 1.0 }
    )

    observer.observe(node)

    return () => {
      observer.unobserve(node)
    }
  }, [callback, canLoadMore])

  return observerRef
}
